// //client/src/pages/public/SearchPage.jsx
// import React, { useState, useEffect } from 'react'
// import { useSearchParams } from 'react-router-dom'
// import { useTranslation } from 'react-i18next'
// import { motion } from 'framer-motion'
// import { Search, Filter, BookOpen, User, Play, X } from 'lucide-react'
// import { Link } from 'react-router-dom'

// const SearchPage = () => {
//   const [searchParams, setSearchParams] = useSearchParams()
//   const { t } = useTranslation()
//   const [query, setQuery] = useState(searchParams.get('q') || '')
//   const [activeFilter, setActiveFilter] = useState('all')
//   const [results, setResults] = useState({
//     poems: [],
//     authors: [],
//     books: [],
//     videos: [],
//   })

//   const filters = [
//     { id: 'all', label: 'All' },
//     { id: 'poems', label: 'Poems' },
//     { id: 'authors', label: 'Authors' },
//     { id: 'books', label: 'Books' },
//     { id: 'videos', label: 'Videos' },
//   ]

//   const sampleResults = {
//     poems: [
//       { id: 1, title: 'Hazaaron Khwahishein Aisi', author: 'Mirza Ghalib', type: 'Ghazal' },
//       { id: 2, title: 'Gulon Mein Rang Bhare', author: 'Faiz Ahmed Faiz', type: 'Nazm' },
//     ],
//     authors: [
//       { id: 1, name: 'Mirza Ghalib', era: 'Classical', poems: 234 },
//       { id: 2, name: 'Faiz Ahmed Faiz', era: 'Modern', poems: 186 },
//     ],
//     books: [
//       { id: 1, title: 'Diwan-e-Ghalib', author: 'Mirza Ghalib', category: 'Rare Books' },
//       { id: 2, title: 'Bang-e-Dara', author: 'Allama Iqbal', category: 'Rare Books' },
//     ],
//     videos: [
//       { id: 1, title: 'Jashn-e-Rekhta 2024', category: 'Mushaira', duration: '45:20' },
//       { id: 2, title: 'Ghazal Recitation', category: 'Podcast', duration: '12:35' },
//     ],
//   }

//   useEffect(() => {
//     if (query) {
//       setResults(sampleResults)
//     }
//   }, [query])

//   const handleSearch = (e) => {
//     e.preventDefault()
//     if (query.trim()) {
//       setSearchParams({ q: query })
//     }
//   }

//   const getFilteredResults = () => {
//     if (activeFilter === 'all') {
//       return [
//         ...results.poems.map(r => ({ ...r, type: 'poem' })),
//         ...results.authors.map(r => ({ ...r, type: 'author' })),
//         ...results.books.map(r => ({ ...r, type: 'book' })),
//         ...results.videos.map(r => ({ ...r, type: 'video' })),
//       ]
//     }
//     return results[activeFilter]?.map(r => ({ ...r, type: activeFilter.slice(0, -1) })) || []
//   }

//   const filteredResults = getFilteredResults()

//   return (
//     <div className="page-container max-w-4xl">
//       <div className="mb-8">
//         <h1 className="section-title">Search</h1>
//         <p className="section-subtitle">Find poems, authors, books, and videos</p>
//       </div>

//       {/* Search Bar */}
//       <form onSubmit={handleSearch} className="mb-8">
//         <div className="relative">
//           <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
//           <input
//             type="text"
//             value={query}
//             onChange={(e) => setQuery(e.target.value)}
//             placeholder="Search poetry, authors, books, videos..."
//             className="input-field pl-12 pr-12 py-3 text-lg"
//           />
//           {query && (
//             <button
//               type="button"
//               onClick={() => { setQuery(''); setSearchParams({}) }}
//               className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
//             >
//               <X className="h-5 w-5" />
//             </button>
//           )}
//         </div>
//       </form>

//       {/* Filters */}
//       <div className="flex overflow-x-auto space-x-2 mb-6 pb-2">
//         {filters.map((filter) => (
//           <button
//             key={filter.id}
//             onClick={() => setActiveFilter(filter.id)}
//             className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
//               activeFilter === filter.id
//                 ? 'bg-primary-600 text-white'
//                 : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
//             }`}
//           >
//             {filter.label}
//           </button>
//         ))}
//       </div>

//       {/* Results */}
//       {query && (
//         <div className="space-y-4">
//           {filteredResults.length > 0 ? (
//             filteredResults.map((result, index) => (
//               <motion.div
//                 key={`${result.type}-${result.id}`}
//                 initial={{ opacity: 0, y: 10 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ delay: index * 0.05 }}
//               >
//                 {result.type === 'poem' && (
//                   <Link to={`/poetry/${result.id}`} className="card p-4 flex items-start space-x-4 hover:shadow-md transition-shadow">
//                     <div className="p-2 bg-primary-50 rounded-lg">
//                       <BookOpen className="h-6 w-6 text-primary-600" />
//                     </div>
//                     <div>
//                       <h3 className="font-medium text-gray-900">{result.title}</h3>
//                       <p className="text-sm text-gray-500">{result.author} · {result.type}</p>
//                     </div>
//                   </Link>
//                 )}
//                 {result.type === 'author' && (
//                   <Link to={`/authors/${result.id}`} className="card p-4 flex items-start space-x-4 hover:shadow-md transition-shadow">
//                     <div className="p-2 bg-secondary-50 rounded-lg">
//                       <User className="h-6 w-6 text-secondary-600" />
//                     </div>
//                     <div>
//                       <h3 className="font-medium text-gray-900">{result.name}</h3>
//                       <p className="text-sm text-gray-500">{result.era} · {result.poems} poems</p>
//                     </div>
//                   </Link>
//                 )}
//                 {result.type === 'book' && (
//                   <Link to={`/books/${result.id}`} className="card p-4 flex items-start space-x-4 hover:shadow-md transition-shadow">
//                     <div className="p-2 bg-blue-50 rounded-lg">
//                       <BookOpen className="h-6 w-6 text-blue-600" />
//                     </div>
//                     <div>
//                       <h3 className="font-medium text-gray-900">{result.title}</h3>
//                       <p className="text-sm text-gray-500">{result.author} · {result.category}</p>
//                     </div>
//                   </Link>
//                 )}
//                 {result.type === 'video' && (
//                   <Link to={`/videos/${result.id}`} className="card p-4 flex items-start space-x-4 hover:shadow-md transition-shadow">
//                     <div className="p-2 bg-red-50 rounded-lg">
//                       <Play className="h-6 w-6 text-red-600" />
//                     </div>
//                     <div>
//                       <h3 className="font-medium text-gray-900">{result.title}</h3>
//                       <p className="text-sm text-gray-500">{result.category} · {result.duration}</p>
//                     </div>
//                   </Link>
//                 )}
//               </motion.div>
//             ))
//           ) : (
//             <div className="text-center py-12">
//               <Search className="h-12 w-12 text-gray-300 mx-auto mb-4" />
//               <p className="text-gray-500">No results found for "{query}"</p>
//             </div>
//           )}
//         </div>
//       )}

//       {!query && (
//         <div className="text-center py-12">
//           <Search className="h-16 w-16 text-gray-200 mx-auto mb-4" />
//           <p className="text-gray-400 text-lg">Start typing to search...</p>
//         </div>
//       )}
//     </div>
//   )
// }

// export default SearchPage














// // client/src/pages/public/SearchPage.jsx
// import React, { useState, useEffect, useCallback, useRef } from 'react'
// import { useSearchParams } from 'react-router-dom'
// import { useTranslation } from 'react-i18next'
// import { motion } from 'framer-motion'
// import { Search, Filter, BookOpen, User, Play, X, Mic, MicOff, Sparkles, Loader2 } from 'lucide-react'
// import { Link } from 'react-router-dom'

// const SearchPage = () => {
//   const [searchParams, setSearchParams] = useSearchParams()
//   const { t } = useTranslation()
//   const [query, setQuery] = useState(searchParams.get('q') || '')
//   const [activeFilter, setActiveFilter] = useState('all')
//   const [isLoading, setIsLoading] = useState(false)
//   const [isListening, setIsListening] = useState(false)
//   const [voiceSupported, setVoiceSupported] = useState(true)
//   const [recognition, setRecognition] = useState(null)
//   const [results, setResults] = useState({
//     poems: [],
//     authors: [],
//     books: [],
//     videos: [],
//   })

//   const filters = [
//     { id: 'all', label: 'All' },
//     { id: 'poems', label: 'Poems' },
//     { id: 'authors', label: 'Authors' },
//     { id: 'books', label: 'Books' },
//     { id: 'videos', label: 'Videos' },
//   ]

//   // Initialize speech recognition
//   useEffect(() => {
//     if ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
//       const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
//       const recognitionInstance = new SpeechRecognition()
//       recognitionInstance.continuous = false
//       recognitionInstance.interimResults = false
//       recognitionInstance.lang = 'en-US'
//       setRecognition(recognitionInstance)
//       setVoiceSupported(true)
//     } else {
//       setVoiceSupported(false)
//     }
//   }, [])

//   const sampleResults = {
//     poems: [
//       { id: 1, title: 'Hazaaron Khwahishein Aisi', author: 'Mirza Ghalib', type: 'Ghazal', slug: 'hazaaron-khwahishein-aisi' },
//       { id: 2, title: 'Gulon Mein Rang Bhare', author: 'Faiz Ahmed Faiz', type: 'Nazm', slug: 'gulon-mein-rang-bhare' },
//       { id: 3, title: 'Lab Pe Aati Hai Dua', author: 'Allama Iqbal', type: 'Nazm', slug: 'lab-pe-aati-hai-dua' },
//     ],
//     authors: [
//       { id: 1, name: 'Mirza Ghalib', era: 'Classical', poems: 234, slug: 'mirza-ghalib' },
//       { id: 2, name: 'Faiz Ahmed Faiz', era: 'Modern', poems: 186, slug: 'faiz-ahmed-faiz' },
//       { id: 3, name: 'Allama Iqbal', era: 'Classical', poems: 156, slug: 'allama-iqbal' },
//     ],
//     books: [
//       { id: 1, title: 'Diwan-e-Ghalib', author: 'Mirza Ghalib', category: 'Rare Books', slug: 'diwan-e-ghalib' },
//       { id: 2, title: 'Bang-e-Dara', author: 'Allama Iqbal', category: 'Rare Books', slug: 'bang-e-dara' },
//       { id: 3, title: 'Nuskha Hai Woh', author: 'Faiz Ahmed Faiz', category: 'Poetry Collection', slug: 'nuskha-hai-woh' },
//     ],
//     videos: [
//       { id: 1, title: 'Jashn-e-Rekhta 2024', category: 'Mushaira', duration: '45:20', slug: 'jashn-e-rekhta-2024' },
//       { id: 2, title: 'Ghazal Recitation', category: 'Performance', duration: '12:35', slug: 'ghazal-recitation' },
//       { id: 3, title: 'Interview with Poet', category: 'Interview', duration: '28:15', slug: 'interview-with-poet' },
//     ],
//   }

//   useEffect(() => {
//     if (query) {
//       performSearch()
//     }
//   }, [query])

//   const performSearch = async () => {
//     setIsLoading(true)
//     // Simulate API call
//     setTimeout(() => {
//       setResults(sampleResults)
//       setIsLoading(false)
//     }, 500)
//   }

//   const handleSearch = (e) => {
//     e.preventDefault()
//     if (query.trim()) {
//       setSearchParams({ q: query })
//     }
//   }

//   // Voice search handler
//   const handleVoiceSearch = useCallback(() => {
//     if (!recognition) {
//       alert('Voice search is not supported in your browser. Please try Chrome, Edge, or Safari.')
//       return
//     }

//     if (isListening) {
//       recognition.stop()
//       setIsListening(false)
//       return
//     }

//     try {
//       setIsListening(true)
      
//       recognition.onresult = (event) => {
//         const transcript = event.results[0][0].transcript
//         setQuery(transcript)
//         setSearchParams({ q: transcript })
//         setIsListening(false)
//       }
      
//       recognition.onerror = (event) => {
//         console.error('Speech recognition error:', event.error)
//         let errorMessage = 'Voice search failed. '
//         if (event.error === 'not-allowed') {
//           errorMessage += 'Please allow microphone access.'
//         } else if (event.error === 'no-speech') {
//           errorMessage += 'No speech detected. Please try again.'
//         } else {
//           errorMessage += 'Please try typing your search.'
//         }
//         alert(errorMessage)
//         setIsListening(false)
//       }
      
//       recognition.onend = () => {
//         setIsListening(false)
//       }
      
//       recognition.start()
//     } catch (error) {
//       console.error('Voice search error:', error)
//       alert('Voice search failed. Please type your search.')
//       setIsListening(false)
//     }
//   }, [recognition, isListening, setSearchParams])

//   const getFilteredResults = () => {
//     if (activeFilter === 'all') {
//       return [
//         ...results.poems.map(r => ({ ...r, type: 'poem' })),
//         ...results.authors.map(r => ({ ...r, type: 'author' })),
//         ...results.books.map(r => ({ ...r, type: 'book' })),
//         ...results.videos.map(r => ({ ...r, type: 'video' })),
//       ]
//     }
//     return results[activeFilter]?.map(r => ({ ...r, type: activeFilter.slice(0, -1) })) || []
//   }

//   const filteredResults = getFilteredResults()

//   return (
//     <div className="min-h-screen pt-20 pb-16 bg-gray-50">
//       <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="mb-8">
//           <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">Search</h1>
//           <p className="text-gray-500">Find poems, authors, books, and videos</p>
//         </div>

//         {/* Search Bar with Voice */}
//         <form onSubmit={handleSearch} className="mb-8">
//           <div className="relative">
//             <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
//             <input
//               type="text"
//               value={query}
//               onChange={(e) => setQuery(e.target.value)}
//               placeholder={voiceSupported ? "Search poetry, authors, books, videos... (Try voice search 🎤)" : "Search poetry, authors, books, videos..."}
//               className="w-full pl-12 pr-32 py-3.5 text-base border border-gray-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white shadow-sm"
//             />
            
//             {/* Voice Search Button */}
//             {voiceSupported && (
//               <button
//                 type="button"
//                 onClick={handleVoiceSearch}
//                 className={`absolute right-20 top-1/2 transform -translate-y-1/2 p-2 rounded-full transition-all duration-200 ${
//                   isListening 
//                     ? 'bg-red-500 text-white animate-pulse shadow-lg' 
//                     : 'text-gray-400 hover:text-primary-600 hover:bg-primary-50'
//                 }`}
//                 title="Voice Search"
//               >
//                 {isListening ? <MicOff className="h-5 w-5" /> : <Mic className="h-5 w-5" />}
//               </button>
//             )}
            
//             {query && (
//               <button
//                 type="button"
//                 onClick={() => { setQuery(''); setSearchParams({}) }}
//                 className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
//               >
//                 <X className="h-5 w-5" />
//               </button>
//             )}
            
//             {/* Voice Recording Indicator */}
//             {isListening && (
//               <div className="absolute -bottom-8 left-0 right-0 text-center">
//                 <span className="text-xs text-red-500 animate-pulse">
//                   🎤 Listening... Speak now
//                 </span>
//               </div>
//             )}
//           </div>
//         </form>

//         {/* Filters */}
//         <div className="flex overflow-x-auto space-x-2 mb-6 pb-2">
//           {filters.map((filter) => (
//             <button
//               key={filter.id}
//               onClick={() => setActiveFilter(filter.id)}
//               className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
//                 activeFilter === filter.id
//                   ? 'bg-primary-600 text-white shadow-md'
//                   : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
//               }`}
//             >
//               {filter.label}
//             </button>
//           ))}
//         </div>

//         {/* Results */}
//         {query && (
//           <div className="space-y-4">
//             {isLoading ? (
//               <div className="flex items-center justify-center py-12">
//                 <Loader2 className="h-8 w-8 animate-spin text-primary-600" />
//               </div>
//             ) : filteredResults.length > 0 ? (
//               filteredResults.map((result, index) => (
//                 <motion.div
//                   key={`${result.type}-${result.id}`}
//                   initial={{ opacity: 0, y: 10 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ delay: index * 0.05 }}
//                 >
//                   {result.type === 'poem' && (
//                     <Link to={`/poetry/${result.slug || result.id}`} className="block bg-white rounded-xl border border-gray-100 p-4 flex items-start space-x-4 hover:shadow-md transition-all hover:border-primary-200">
//                       <div className="p-2 bg-primary-50 rounded-lg">
//                         <BookOpen className="h-6 w-6 text-primary-600" />
//                       </div>
//                       <div className="flex-1">
//                         <h3 className="font-medium text-gray-900">{result.title}</h3>
//                         <p className="text-sm text-gray-500">{result.author} · {result.type}</p>
//                       </div>
//                     </Link>
//                   )}
//                   {result.type === 'author' && (
//                     <Link to={`/authors/${result.slug || result.id}`} className="block bg-white rounded-xl border border-gray-100 p-4 flex items-start space-x-4 hover:shadow-md transition-all hover:border-green-200">
//                       <div className="p-2 bg-green-50 rounded-lg">
//                         <User className="h-6 w-6 text-green-600" />
//                       </div>
//                       <div className="flex-1">
//                         <h3 className="font-medium text-gray-900">{result.name}</h3>
//                         <p className="text-sm text-gray-500">{result.era} · {result.poems} poems</p>
//                       </div>
//                     </Link>
//                   )}
//                   {result.type === 'book' && (
//                     <Link to={`/books/${result.slug || result.id}`} className="block bg-white rounded-xl border border-gray-100 p-4 flex items-start space-x-4 hover:shadow-md transition-all hover:border-purple-200">
//                       <div className="p-2 bg-purple-50 rounded-lg">
//                         <BookOpen className="h-6 w-6 text-purple-600" />
//                       </div>
//                       <div className="flex-1">
//                         <h3 className="font-medium text-gray-900">{result.title}</h3>
//                         <p className="text-sm text-gray-500">{result.author} · {result.category}</p>
//                       </div>
//                     </Link>
//                   )}
//                   {result.type === 'video' && (
//                     <Link to={`/videos/${result.slug || result.id}`} className="block bg-white rounded-xl border border-gray-100 p-4 flex items-start space-x-4 hover:shadow-md transition-all hover:border-red-200">
//                       <div className="p-2 bg-red-50 rounded-lg">
//                         <Play className="h-6 w-6 text-red-600" />
//                       </div>
//                       <div className="flex-1">
//                         <h3 className="font-medium text-gray-900">{result.title}</h3>
//                         <p className="text-sm text-gray-500">{result.category} · {result.duration}</p>
//                       </div>
//                     </Link>
//                   )}
//                 </motion.div>
//               ))
//             ) : (
//               <div className="text-center py-12 bg-white rounded-xl border border-gray-100">
//                 <Search className="h-12 w-12 text-gray-300 mx-auto mb-4" />
//                 <p className="text-gray-500">No results found for "{query}"</p>
//                 <p className="text-sm text-gray-400 mt-2">Try different keywords or check your spelling</p>
//               </div>
//             )}
//           </div>
//         )}

//         {!query && (
//           <div className="text-center py-12">
//             <Search className="h-16 w-16 text-gray-200 mx-auto mb-4" />
//             <p className="text-gray-400 text-lg">Start typing to search...</p>
//             {voiceSupported && (
//               <p className="text-sm text-gray-400 mt-2">
//                 Or click the microphone button for voice search 🎤
//               </p>
//             )}
//           </div>
//         )}
//       </div>
//     </div>
//   )
// }

// export default SearchPage

















// client/src/pages/public/SearchPage.jsx
import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useSearchParams, Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { motion, AnimatePresence } from 'framer-motion'
import { Search, BookOpen, User, Play, X, Mic, MicOff, Loader2, TrendingUp, Clock, Sparkles } from 'lucide-react'
import searchAPI from '../../api/searchAPI'

const SearchPage = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const { t } = useTranslation()
  const [query, setQuery] = useState(searchParams.get('q') || '')
  const [activeFilter, setActiveFilter] = useState('all')
  const [isLoading, setIsLoading] = useState(false)
  const [isListening, setIsListening] = useState(false)
  const [voiceSupported, setVoiceSupported] = useState(true)
  const [results, setResults] = useState({
    poems: [],
    authors: [],
    books: [],
    audio: [],
    videos: [],
  })
  const [trendingSearches, setTrendingSearches] = useState([])
  const [recentSearches, setRecentSearches] = useState([])
  const [suggestions, setSuggestions] = useState([])
  const [showSuggestions, setShowSuggestions] = useState(false)
  const [isAISearch, setIsAISearch] = useState(false)
  const inputRef = useRef(null)

  const filters = [
    { id: 'all', label: 'All', icon: '🔍' },
    { id: 'poems', label: 'Poems', icon: '📖' },
    { id: 'authors', label: 'Authors', icon: '👤' },
    { id: 'books', label: 'Books', icon: '📚' },
    { id: 'audio', label: 'Audio', icon: '🎵' },
    { id: 'videos', label: 'Videos', icon: '🎬' },
  ]

  // Load trending searches
  useEffect(() => {
    const loadTrending = async () => {
      try {
        const response = await searchAPI.getTrendingSearches()
        setTrendingSearches(response?.data || response || [])
      } catch (error) {
        console.error('Error loading trending searches:', error)
      }
    }
    loadTrending()
    
    // Load recent searches from localStorage
    const saved = localStorage.getItem('recentSearches')
    if (saved) {
      setRecentSearches(JSON.parse(saved).slice(0, 5))
    }
  }, [])

  // Save search to recent searches
  const saveRecentSearch = (searchQuery) => {
    if (!searchQuery || searchQuery.length < 2) return
    const updated = [searchQuery, ...recentSearches.filter(s => s !== searchQuery)].slice(0, 5)
    setRecentSearches(updated)
    localStorage.setItem('recentSearches', JSON.stringify(updated))
  }

  // Fetch suggestions
  useEffect(() => {
    const fetchSuggestions = async () => {
      if (query.length >= 2) {
        try {
          const response = await searchAPI.getSuggestions(query)
          setSuggestions(response?.data || response || [])
          setShowSuggestions(true)
        } catch (error) {
          console.error('Error fetching suggestions:', error)
        }
      } else {
        setSuggestions([])
        setShowSuggestions(false)
      }
    }
    const timer = setTimeout(fetchSuggestions, 300)
    return () => clearTimeout(timer)
  }, [query])

  // Perform search
  const performSearch = async (searchQuery = query) => {
    if (!searchQuery || searchQuery.length < 2) {
      setResults({ poems: [], authors: [], books: [], audio: [], videos: [] })
      return
    }

    setIsLoading(true)
    saveRecentSearch(searchQuery)
    
    try {
      let response
      
      if (activeFilter === 'all') {
        response = await searchAPI.search(searchQuery, 'all', { limit: 50 })
        setResults({
          poems: response?.data?.poems || response?.poems || [],
          authors: response?.data?.authors || response?.authors || [],
          books: response?.data?.books || response?.books || [],
          audio: response?.data?.audio || response?.audio || [],
          videos: response?.data?.videos || response?.videos || [],
        })
      } else {
        // Search specific type
        switch (activeFilter) {
          case 'poems':
            response = await searchAPI.searchPoems(searchQuery, { limit: 50 })
            setResults({ ...results, poems: response?.data?.data || response?.data || response || [] })
            break
          case 'authors':
            response = await searchAPI.searchAuthors(searchQuery, { limit: 50 })
            setResults({ ...results, authors: response?.data?.data || response?.data || response || [] })
            break
          case 'books':
            response = await searchAPI.searchBooks(searchQuery, { limit: 50 })
            setResults({ ...results, books: response?.data?.data || response?.data || response || [] })
            break
          case 'audio':
            response = await searchAPI.searchAudio(searchQuery, { limit: 50 })
            setResults({ ...results, audio: response?.data?.data || response?.data || response || [] })
            break
          case 'videos':
            response = await searchAPI.searchVideos(searchQuery, { limit: 50 })
            setResults({ ...results, videos: response?.data?.data || response?.data || response || [] })
            break
          default:
            break
        }
      }
    } catch (error) {
      console.error('Search error:', error)
    } finally {
      setIsLoading(false)
    }
  }

  // AI Semantic Search
  const handleAISearch = async () => {
    if (!query || query.length < 2) return
    
    setIsAISearch(true)
    setIsLoading(true)
    
    try {
      const type = activeFilter === 'all' ? 'all' : activeFilter.slice(0, -1)
      const response = await searchAPI.semanticSearch(query, type)
      const semanticResults = response?.data?.results || response?.results || []
      
      // Group semantic results by type
      const groupedResults = {
        poems: [],
        authors: [],
        books: [],
        audio: [],
        videos: [],
      }
      
      semanticResults.forEach(item => {
        if (item.contentType === 'poem') groupedResults.poems.push(item)
        else if (item.contentType === 'author') groupedResults.authors.push(item)
        else if (item.contentType === 'book') groupedResults.books.push(item)
        else if (item.contentType === 'audio') groupedResults.audio.push(item)
        else if (item.contentType === 'video') groupedResults.videos.push(item)
      })
      
      setResults(groupedResults)
    } catch (error) {
      console.error('AI search error:', error)
      // Fallback to regular search
      await performSearch(query)
    } finally {
      setIsAISearch(false)
      setIsLoading(false)
    }
  }

  // Voice search handler
  const handleVoiceSearch = useCallback(async () => {
    if (isListening) {
      setIsListening(false)
      return
    }

    try {
      setIsListening(true)
      const result = await searchAPI.voiceSearch(null, 'en')
      if (result?.query) {
        setQuery(result.query)
        setSearchParams({ q: result.query })
        await performSearch(result.query)
      }
    } catch (error) {
      console.error('Voice search error:', error)
      alert('Voice search failed. Please type your search.')
    } finally {
      setIsListening(false)
    }
  }, [isListening, setSearchParams])

  const handleSearch = async (e) => {
    e.preventDefault()
    if (query.trim()) {
      setSearchParams({ q: query })
      await performSearch(query)
    }
  }

  const handleFilterChange = async (filterId) => {
    setActiveFilter(filterId)
    if (query) {
      await performSearch(query)
    }
  }

  const handleSuggestionClick = (suggestion) => {
    setQuery(suggestion.title)
    setShowSuggestions(false)
    setSearchParams({ q: suggestion.title })
    performSearch(suggestion.title)
  }

  const handleTrendingClick = (term) => {
    setQuery(term)
    setSearchParams({ q: term })
    performSearch(term)
  }

  const clearSearch = () => {
    setQuery('')
    setSearchParams({})
    setResults({ poems: [], authors: [], books: [], audio: [], videos: [] })
    setSuggestions([])
    setShowSuggestions(false)
  }

  // Get filtered results based on active tab
  const getFilteredResults = () => {
    if (activeFilter === 'all') {
      return [
        ...results.poems.map(r => ({ ...r, type: 'poem' })),
        ...results.authors.map(r => ({ ...r, type: 'author' })),
        ...results.books.map(r => ({ ...r, type: 'book' })),
        ...results.audio.map(r => ({ ...r, type: 'audio' })),
        ...results.videos.map(r => ({ ...r, type: 'video' })),
      ]
    }
    
    const key = activeFilter
    return results[key]?.map(r => ({ ...r, type: key.slice(0, -1) })) || []
  }

  const filteredResults = getFilteredResults()
  const totalResults = filteredResults.length

  // Render result card based on type
  const renderResultCard = (result, index) => {
    const getIcon = () => {
      switch (result.type) {
        case 'poem': return <BookOpen className="h-5 w-5 text-blue-600" />
        case 'author': return <User className="h-5 w-5 text-green-600" />
        case 'book': return <BookOpen className="h-5 w-5 text-purple-600" />
        case 'audio': return <Play className="h-5 w-5 text-orange-600" />
        case 'video': return <Play className="h-5 w-5 text-red-600" />
        default: return <Search className="h-5 w-5 text-gray-600" />
      }
    }

    const getLinkPath = () => {
      switch (result.type) {
        case 'poem': return `/poetry/${result.slug || result._id}`
        case 'author': return `/authors/${result.slug || result._id}`
        case 'book': return `/books/${result.slug || result._id}`
        case 'audio': return `/audio/${result.slug || result._id}`
        case 'video': return `/videos/${result.slug || result._id}`
        default: return '#'
      }
    }

    const getSubtitle = () => {
      switch (result.type) {
        case 'poem': return `${result.author?.name || 'Unknown Author'} · ${result.genre || 'Poetry'}`
        case 'author': return `${result.era || 'Poet'} · ${result.poems?.length || 0} poems`
        case 'book': return `${result.author?.name || 'Unknown Author'} · ${result.type || 'Book'}`
        case 'audio': return `${result.author?.name || 'Unknown Artist'} · ${result.type || 'Audio'} · ${result.duration ? `${Math.floor(result.duration / 60)} min` : ''}`
        case 'video': return `${result.author?.name || 'Unknown Creator'} · ${result.type || 'Video'} · ${result.duration ? `${Math.floor(result.duration / 60)} min` : ''}`
        default: return ''
      }
    }

    const getBgColor = () => {
      switch (result.type) {
        case 'poem': return 'bg-blue-50 hover:border-blue-200'
        case 'author': return 'bg-green-50 hover:border-green-200'
        case 'book': return 'bg-purple-50 hover:border-purple-200'
        case 'audio': return 'bg-orange-50 hover:border-orange-200'
        case 'video': return 'bg-red-50 hover:border-red-200'
        default: return 'bg-gray-50 hover:border-gray-200'
      }
    }

    return (
      <motion.div
        key={`${result.type}-${result._id || result.id}`}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: index * 0.05 }}
      >
        <Link to={getLinkPath()} className={`block bg-white rounded-xl border border-gray-100 p-4 flex items-start space-x-4 hover:shadow-md transition-all ${getBgColor()}`}>
          <div className="p-2 rounded-lg bg-white shadow-sm">
            {getIcon()}
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-medium text-gray-900 truncate">{result.title || result.name}</h3>
            <p className="text-sm text-gray-500">{getSubtitle()}</p>
            {result.description && (
              <p className="text-xs text-gray-400 mt-1 line-clamp-2">{result.description.substring(0, 100)}</p>
            )}
          </div>
          <div className="text-xs text-gray-400 capitalize">
            {result.type}
          </div>
        </Link>
      </motion.div>
    )
  }

  return (
    <div className="min-h-screen pt-20 pb-16 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
            Search
          </h1>
          <p className="text-gray-500">
            Find poems, authors, books, audio, and videos
          </p>
        </div>

        {/* Search Bar with Voice and AI */}
        <form onSubmit={handleSearch} className="mb-6">
          <div className="relative">
            <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
            <input
              ref={inputRef}
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onFocus={() => suggestions.length > 0 && setShowSuggestions(true)}
              onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
              placeholder={voiceSupported ? "Search poetry, authors, books, audio, videos... (Try voice search 🎤)" : "Search poetry, authors, books, audio, videos..."}
              className="w-full pl-12 pr-32 py-3.5 text-base border border-gray-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white shadow-sm"
            />
            
            {/* Voice Search Button */}
            {voiceSupported && (
              <button
                type="button"
                onClick={handleVoiceSearch}
                className={`absolute right-24 top-1/2 transform -translate-y-1/2 p-2 rounded-full transition-all duration-200 ${
                  isListening 
                    ? 'bg-red-500 text-white animate-pulse shadow-lg' 
                    : 'text-gray-400 hover:text-primary-600 hover:bg-primary-50'
                }`}
                title="Voice Search"
              >
                {isListening ? <MicOff className="h-5 w-5" /> : <Mic className="h-5 w-5" />}
              </button>
            )}
            
            {/* AI Search Button */}
            <button
              type="button"
              onClick={handleAISearch}
              disabled={!query || query.length < 2 || isAISearch}
              className={`absolute right-14 top-1/2 transform -translate-y-1/2 p-2 rounded-full transition-all duration-200 ${
                isAISearch 
                  ? 'bg-primary-500 text-white' 
                  : 'text-gray-400 hover:text-primary-600 hover:bg-primary-50'
              } disabled:opacity-50 disabled:cursor-not-allowed`}
              title="AI Semantic Search"
            >
              {isAISearch ? <Loader2 className="h-5 w-5 animate-spin" /> : <Sparkles className="h-5 w-5" />}
            </button>
            
            {query && (
              <button
                type="button"
                onClick={clearSearch}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                <X className="h-5 w-5" />
              </button>
            )}
            
            {/* Voice Recording Indicator */}
            {isListening && (
              <div className="absolute -bottom-8 left-0 right-0 text-center">
                <span className="text-xs text-red-500 animate-pulse">
                  🎤 Listening... Speak now
                </span>
              </div>
            )}
          </div>
        </form>

        {/* Suggestions Dropdown */}
        <AnimatePresence>
          {showSuggestions && suggestions.length > 0 && !isLoading && (
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              className="relative -mt-4 mb-4 z-10"
            >
              <div className="absolute top-0 left-0 right-0 bg-white border border-gray-200 rounded-xl shadow-lg max-h-80 overflow-y-auto">
                {suggestions.map((suggestion, index) => (
                  <button
                    key={index}
                    onClick={() => handleSuggestionClick(suggestion)}
                    className="w-full text-left px-4 py-3 hover:bg-gray-50 flex items-center gap-3 border-b border-gray-100 last:border-0"
                  >
                    <span className="text-xl">
                      {suggestion.type === 'poem' ? '📖' : suggestion.type === 'author' ? '👤' : suggestion.type === 'book' ? '📚' : '🎵'}
                    </span>
                    <div className="flex-1">
                      <p className="text-sm font-medium text-gray-900">{suggestion.title}</p>
                      <p className="text-xs text-gray-500">{suggestion.category || suggestion.type}</p>
                    </div>
                    <Search className="h-4 w-4 text-gray-400" />
                  </button>
                ))}
              </div>
            </motion.div>
          )}
        </AnimatePresence>

        {/* Trending and Recent Searches */}
        {(trendingSearches.length > 0 || recentSearches.length > 0) && !query && !isLoading && (
          <div className="mb-6 flex flex-wrap gap-6">
            {trendingSearches.length > 0 && (
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <TrendingUp className="h-4 w-4 text-orange-500" />
                  <span className="text-xs font-medium text-gray-500">Trending</span>
                </div>
                <div className="flex flex-wrap gap-2">
                  {trendingSearches.slice(0, 5).map((item, idx) => (
                    <button
                      key={idx}
                      onClick={() => handleTrendingClick(typeof item === 'string' ? item : item.term)}
                      className="px-3 py-1.5 bg-gray-100 hover:bg-gray-200 rounded-full text-sm text-gray-700 transition-colors"
                    >
                      {typeof item === 'string' ? item : item.term}
                    </button>
                  ))}
                </div>
              </div>
            )}
            {recentSearches.length > 0 && (
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <Clock className="h-4 w-4 text-blue-500" />
                  <span className="text-xs font-medium text-gray-500">Recent</span>
                </div>
                <div className="flex flex-wrap gap-2">
                  {recentSearches.map((term, idx) => (
                    <button
                      key={idx}
                      onClick={() => handleTrendingClick(term)}
                      className="px-3 py-1.5 bg-gray-100 hover:bg-gray-200 rounded-full text-sm text-gray-700 transition-colors"
                    >
                      {term}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}

        {/* Results Count */}
        {query && totalResults > 0 && !isLoading && (
          <div className="mb-4 text-sm text-gray-500">
            Found {totalResults} result{totalResults !== 1 ? 's' : ''} for "{query}"
            {isAISearch && <span className="ml-2 text-primary-600"> (AI-powered search)</span>}
          </div>
        )}

        {/* Filters */}
        <div className="flex overflow-x-auto space-x-2 mb-6 pb-2 scrollbar-hide">
          {filters.map((filter) => (
            <button
              key={filter.id}
              onClick={() => handleFilterChange(filter.id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
                activeFilter === filter.id
                  ? 'bg-primary-600 text-white shadow-md'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              <span>{filter.icon}</span>
              <span>{filter.label}</span>
              {activeFilter === filter.id && query && totalResults > 0 && (
                <span className="ml-1 px-1.5 py-0.5 bg-white/20 text-white text-xs rounded-full">
                  {filter.id === 'all' ? totalResults : results[filter.id]?.length || 0}
                </span>
              )}
            </button>
          ))}
        </div>

        {/* Results */}
        {query && (
          <div className="space-y-4">
            {isLoading ? (
              <div className="flex items-center justify-center py-12">
                <Loader2 className="h-8 w-8 animate-spin text-primary-600" />
                {isAISearch && <span className="ml-2 text-gray-500">AI is thinking...</span>}
              </div>
            ) : filteredResults.length > 0 ? (
              filteredResults.map((result, index) => renderResultCard(result, index))
            ) : (
              <div className="text-center py-12 bg-white rounded-xl border border-gray-100">
                <Search className="h-12 w-12 text-gray-300 mx-auto mb-4" />
                <p className="text-gray-500">No results found for "{query}"</p>
                <p className="text-sm text-gray-400 mt-2">Try different keywords or check your spelling</p>
                {voiceSupported && (
                  <button
                    onClick={handleVoiceSearch}
                    className="mt-4 inline-flex items-center gap-2 px-4 py-2 bg-primary-50 text-primary-600 rounded-lg hover:bg-primary-100 transition-colors"
                  >
                    <Mic className="h-4 w-4" />
                    Try voice search instead
                  </button>
                )}
              </div>
            )}
          </div>
        )}

        {!query && !isLoading && (
          <div className="text-center py-12">
            <Search className="h-16 w-16 text-gray-200 mx-auto mb-4" />
            <p className="text-gray-400 text-lg">Start typing to search...</p>
            {voiceSupported && (
              <p className="text-sm text-gray-400 mt-2">
                Or click the microphone button for voice search 🎤
              </p>
            )}
            <p className="text-xs text-gray-400 mt-4">
              Try searching for: "Marsiya", "Nauha", "Ghalib", "Urdu Poetry"
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default SearchPage